import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '../views/layout/Layout'
import { getToken } from '@/utils/auth'
const _import = require('./_import_' + process.env.NODE_ENV)

Vue.use(Router)
let path = ''
// if (process.env.NODE_ENV !== 'development') {
//   path = '/qianduan'
// }
const routes = [
  { // 首页部分
    path: path + '',
    component: Layout,
    children: [
      {
        path: '',
        component: _import('index/index'),
        meta: { title: '在线客服' }
      },
      {
        path: '/index/test',
        component: _import('index/test'),
        meta: { title: '测试' }
      },
      {
        path: '/clean',
        component: _import('index/clean'),
        meta: { title: '清除缓存' }
      }
    ]
  },
  { // 登录
    path: path + '/login',
    component: Layout,
    name: 'login',
    children: [
      {
        path: 'index',
        component: _import('login/index'),
        meta: { title: '登录' }
      }
    ]
  },
  { // 基因解读
    path: path + '/gene',
    component: Layout,
    name: 'gene',
    children: [
      {
        path: 'index',
        component: _import('gene/index'),
        meta: { title: '基因解读' }
      },
      {
        path: 'xy',
        component: _import('gene/xy'),
        meta: { title: '基因报告解读隐私政策' }
      }
    ]
  },
  { // 预约参观
    path: path + '/appoint',
    component: Layout,
    name: 'appoint',
    children: [
      {
        path: 'index',
        component: _import('globel/appoint'),
        meta: { title: '预约参观' }
      }
    ]
  },
  { // 全局
    path: path + '/globel',
    component: Layout,
    name: 'globel',
    children: [
      {
        path: 'success',
        component: _import('globel/success'),
        meta: { title: '信息已提交' }
      },
      {
        path: 'success-page',
        component: _import('globel/successPage'),
        meta: { title: '信息已提交' }
      },
      {
        path: 'fail',
        component: _import('globel/fail'),
        meta: { title: '填写信息' }
      },
      {
        path: 'yx-card',
        component: _import('globel/yx-card'),
        meta: { title: '个人名片' }
      },
      {
        path: 'zx-vote',
        component: _import('globel/zx-vote'),
        meta: { title: '2020中源协和最美咨询师风采大赛' }
      }
    ]
  },
  { // 捐赠
    path: path + '/juan',
    component: Layout,
    children: [
      {
        path: '',
        component: _import('juan/index'),
        meta: { title: '预约捐献' }
      },
      {
        path: '/juan/answer',
        component: _import('juan/answer'),
        meta: { title: '对脐带血的了解' }
      },
      {
        path: '/juan/from',
        component: _import('juan/juanFrom'),
        meta: { title: '预约捐献' }
      }
    ]
  },
  { // 外部链接表单
    path: path + '/url',
    component: Layout,
    children: [
      {
        path: '',
        component: _import('url/index'),
        meta: { title: '填写信息' }
      }
    ]
  },
  { // 问卷调查
    path: path + '/question',
    component: Layout,
    name: 'question',
    children: [
      {
        path: 'ask',
        component: _import('question/ask'),
        meta: { title: '问卷调查' }
      },
      {
        path: 'ask-detail',
        component: _import('question/askDetail'),
        meta: { title: '问卷调查' }
      }
    ]
  },
  { // 问卷调查答案
    path: path + '/qx-question',
    component: Layout,
    name: 'qx-question',
    children: [
      {
        path: 'index',
        component: _import('qxQuestion/index'),
        meta: { title: '结果统计' }
      },
      {
        path: 'detail',
        component: _import('qxQuestion/detail'),
        meta: { title: '问卷详情' }
      }
    ]
  },
  { // 通用页面
    path: path + '/nianjian-zan',
    component: Layout,
    name: 'nianjian',
    children: [
      {
        path: 'index',
        component: _import('globelPages/njZanIndex'),
        meta: { title: '年监海报集赞' }
      },
      {
        path: 'detail',
        component: _import('globelPages/njZanDetail'),
        meta: { title: '年监海报集赞' }
      }
    ]
  },
  { // 通用页面
    path: path + '/globel-page',
    component: Layout,
    name: 'globel-page',
    children: [
      {
        path: 'xrbp',
        component: _import('globelPages/xrbp'),
        meta: { title: '夏日大比拼' }
      },
      {
        path: 'xrbp202008',
        component: _import('globelPages/xrbp202008'),
        meta: { title: '热辣8月' }
      },
      {
        path: 'qi',
        component: _import('globelPages/qi'),
        meta: { title: '2020世界脐带血日' }
      },
      {
        path: 'bjsd',
        component: _import('globelPages/bjsd'),
        meta: { title: '2020中源协和人气团队投票' }
      },
      {
        path: 'bjsd-ad',
        component: _import('globelPages/bjsd-ad'),
        meta: { title: '2020中源协和人气团队投票' }
      }
    ]
  },
  // 答题抽奖
  {
    path: path + '/competition',
    component: _import('competition/index'),
    name: 'competition',
    children: [
      {
        path: 'ask',
        component: _import('competition/components/ask'),
        meta: { title: '答题' }
      },
      {
        path: 'ask-detail',
        component: _import('competition/components/ask-detail'),
        meta: { title: '答题' }
      },
      {
        path: 'modal',
        component: _import('competition/components/modal'),
        meta: { title: '答题' }
      },
      {
        path: 'lottery',
        name: 'lottery',
        component: _import('competition/components/lottery'),
        meta: { title: '答题' }
      },
      {
        path: 'fraction',
        name: 'fraction',
        component: _import('competition/components/fraction'),
        meta: { title: '答题' }
      },
      {
        path: '/submit',
        name: 'submit',
        component: _import('competition/components/submit'),
        meta: { title: '答题' }
      }
    ]
  },
  // 知识之星
  {
    path: path + '/assess',
    component: Layout,
    name: 'assess',
    children: [
      {
        path: 'ask',
        component: _import('assess/ask'),
        meta: { title: '知识对决赛' }
      },
      {
        path: 'ask-detail',
        component: _import('assess/ask-detail'),
        meta: { title: '知识对决赛' }
      },
      {
        path: 'user-info',
        name: 'user-info',
        component: _import('assess/user-info'),
        meta: { title: '知识对决赛' }
      },
      {
        path: 'score',
        name: 'score',
        component: _import('assess/score'),
        meta: { title: '知识对决赛' }
      },
    ]
  },
  // 2026开门红•云催繳线上知识竞赛
  {
    path: path + '/collection',
    component: Layout,
    name: 'collection',
    children: [
      {
        path: 'ask',
        component: _import('collection/ask'),
        meta: { title: '2026开门红•云催繳线上知识竞赛' }
      },
      {
        path: 'detail',
        name: 'detail',
        component: _import('collection/detail'),
        meta: { title: '2026开门红•云催繳线上知识竞赛' }
      },
      {
        path: 'user',
        component: _import('collection/user'),
        meta: { title: '2026开门红•云催繳线上知识竞赛' }
      },
      {
        path: 'score',
        component: _import('collection/score'),
        meta: { title: '2026开门红•云催繳线上知识竞赛' }
      },
    ]
  },
  // 24.8 新生儿线索收集
  {
    path: path + '/clue',
    component: Layout,
    name: 'clue',
    children: [
      {
        path: 'invite',
        component: _import('clueCollection/inviteView'),
        meta: { title: '孕满中秋·助力共享好礼' }
      },
      {
        path: 'assist',
        component: _import('clueCollection/assistView'),
        meta: { title: '孕满中秋·助力共享好礼' }
      },
      {
        path: 'poster',
        component: _import('clueCollection/posterView'),
        meta: { title: '孕满中秋·助力共享好礼' }
      },
      {
        path: 'inviteEnd',
        component: _import('clueCollection/inviteEnd'),
        meta: { title: '孕满中秋·助力共享好礼' }
      },
      {
        path: 'invited',
        component: _import('clueCollection/invitedView'),
        meta: { title: '孕满中秋·助力共享好礼' }
      },
      {
        path: 'success',
        component: _import('clueCollection/success'),
        meta: { title: '孕满中秋·助力共享好礼' }
      },
      {
        path: 'invitedEnd',
        component: _import('clueCollection/invitedEnd'),
        meta: { title: '孕满中秋·助力共享好礼' }
      },
    ]
  },
  // 保险告知函
  {
    path: path + '/insurance',
    component: Layout,
    name: 'insurance',
    children: [
      {
        path: 'invite',
        component: _import('insurance/inviteView'),
        meta: { title: '生命银行权益告知函' }
      },
      {
        path: 'poster',
        component: _import('insurance/posterView'),
        meta: { title: '生命银行权益告知函' }
      },
      {
        path: 'assist',
        component: _import('insurance/assistView'),
        meta: { title: '生命银行权益告知函' }
      },
      {
        path: 'statistics',
        component: _import('insurance/statistics'),
        meta: { title: '数据统计' }
      },
    ]
  },
  // 储户续签 信息收集
  {
    path: path + '/renewal',
    component: Layout,
    name: 'renewal',
    children: [
      {
        path: 'index',
        component: _import('renewal/index'),
        meta: { title: '深秋宠粉 脐爱延续' }
      },
    ]
  },
  // 理赔调查问卷
  {
    path: path + '/claims',
    component: Layout,
    name: 'claims',
    children: [
      {
        path: 'index',
        component: _import('claimsQuestionnaire/index'),
        meta: { title: '理赔调查问卷' }
      },
    ]
  },
  // 2025 3.8女神节活动
  {
    path: path + '/goddess',
    component: Layout,
    name: 'clue',
    children: [
      {
        path: 'invited',
        component: _import('goddessActivity/invitedView'),
        meta: {title: '初春遇见·好孕相伴'}
      },
      {
        path: 'success',
        component: _import('goddessActivity/success'),
        meta: {title: '初春遇见·好孕相伴'}
      },
      {
        path: 'invitedEnd',
        component: _import('goddessActivity/invitedEnd'),
        meta: {title: '初春遇见·好孕相伴'}
      },
    ]
  },
  // 2025 4.11 在线缴费抽奖活动
  {
    path: path + '/payment-draw',
    component: Layout,
    name: 'payment',
    children: [
      {
        path: '',
        component: _import('paymentDraw/index'),
        meta: {title: '春日缴费礼·趣享露营季'}
      },
    ]
  },
  // 2025 5.28 端午节活动
  {
    path: path + '/dragon-boat',
    component: Layout,
    name: 'dragon-boat',
    children: [
      {
        path: '',
        component: _import('dragonBoat/index'),
        meta: {title: '暖冬赠好礼 续存启新章'}
      },
    ]
  },
  // 2026开门红•云催繳线上知识竞赛
  {
    path: path + '/assessment',
    component: Layout,
    name: 'assessment',
    children: [
      {
        path: 'ask',
        component: _import('assessment/ask'),
        meta: { title: '2026开门红•云催繳线上知识竞赛' }
      },
      {
        path: 'ask-detail',
        component: _import('assessment/ask-detail'),
        meta: { title: '2026开门红•云催繳线上知识竞赛' }
      },
      {
        path: 'user-info',
        name: 'user-info',
        component: _import('assessment/user-info'),
        meta: { title: '2026开门红•云催繳线上知识竞赛' }
      },
      {
        path: 'score',
        name: 'score',
        component: _import('assessment/score'),
        meta: { title: '2026开门红•云催繳线上知识竞赛' }
      },
    ]
  },
]

const router = new Router({
  mode: 'history',
  routes: routes
})

// var _hmt = window._hmt || []

router.beforeEach((to, from, next) => {
  if (to.meta.title) { // 如果设置标题，拦截后设置标题
    if (to.meta.title === '登录' && getToken()) { // hack登录后返回显示登录title，但还在在线客服页
      document.title = from.meta.title
    } else {
      document.title = to.meta.title
    }
  }
  if (from.path == '/competition/fraction' && to.path == '/competition/ask-detail' ) {
    next('/competition/ask')
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js